import React, { useState, useEffect } from "react";

const CircularTimer = ({publish_date, start_time, end_time }) => {
  // Helper to convert "HH:mm:ss" to Date object (using today's date)
  const parseTime = (timeString) => {
    const [hours, minutes, seconds] = timeString.split(":").map(Number);
    const _date = new Date(publish_date);
    console.log("sss", publish_date, _date)
    return new Date(
      _date.getFullYear(),
      _date.getMonth(),
      _date.getDate(),
      hours,
      minutes,
      seconds
    );
  };

  const startTime = parseTime(start_time);
  const endTime = parseTime(end_time);
  const totalDuration = (endTime - startTime) / 1000; // Total duration in seconds

  const [remainingTime, setRemainingTime] = useState(
    Math.max(0, (endTime - new Date()) / 1000) // Initial remaining time
  );

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const timeLeft = Math.max(0, (endTime - now) / 1000);
      setRemainingTime(timeLeft);
      // Clear interval if time is up
      if (timeLeft <= 0) {
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, [endTime]);

  // Calculate percentage progress and color
  const percentage = (remainingTime / totalDuration) * 100;
  const progressColor = percentage <= 30 ? "red" : "green";

  const formatTime = (seconds) => {
    if (seconds >= 3600) {
      // More than 1 hour
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")} Hr`;
    } else if (seconds >= 60) {
      // More than 1 minute
      const minutes = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")} Min`;
    } else {
      // Less than 1 minute
      return `00:${String(Math.ceil(seconds)).padStart(2, "0")} Sec`;
    }
  };
  
  

  return remainingTime > 0 ? (
    <div style={{ width: "80px", height: "80px", position: "relative" }}>
      <svg viewBox="0 0 36 36" style={{ transform: "rotate(-90deg)" }}>
        {/* Background Circle */}
        <circle
          cx="18"
          cy="18"
          r="16"
          stroke="#ddd"
          strokeWidth="2"
          fill="none"
        />
        {/* Progress Circle */}
        <circle
          cx="18"
          cy="18"
          r="16"
          stroke={progressColor}
          strokeWidth="2"
          fill="none"
          strokeDasharray="100"
          strokeDashoffset={100 - percentage}
          style={{ transition: "stroke-dashoffset 0.5s, stroke 0.5s" }}
        />
      </svg>
      {/* Time Text */}
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          fontSize: "16px",
          color: progressColor,
          textAlign: "center",
        }}
      >
        {formatTime(remainingTime)}
      </div>
    </div>
  ) : null;
};

export default CircularTimer;
